import { Button, Card, Flex, Text, TextField } from "@engaging-tech/components"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { isValidEmail } from "../../userGeneratedContent/lib/utils"
import forcedIdentityConsentContainer from "../containers/forcedIdentityConsent.container"
import SurveyLogo from "./surveyLogo"

const ForcedIdentityConsent = ({ onNext, onPrevious, setIdentityConsent, optionalUserEmail }) => {
  const [email, setEmail] = useState(() => optionalUserEmail || "")
  const [error, setError] = useState(false)
  const { t } = useTranslation(["organisation_survey"])

  const handleNext = () => {
    if (!email || !isValidEmail(email)) {
      setError(true)
      return
    }
    setIdentityConsent({ isAnonymous: false, optionalUserEmail: email })
    onNext()
  }

  return (
    <Card bg="light.0" mt={[5, 5, 6]} mb={[6, 5]} elevation={8} px={4}>
      <Flex flexDirection="column" py={3} px={[3, 4]} alignContent="center">
        <SurveyLogo />
        <Text
          color="dark.1"
          fontSize={4}
          textAlign="center"
          my={3}
          fontWeight={500}
          style={{ whiteSpace: "pre-line" }}
        >
          {t("identity_consent.forced_description", "")}
        </Text>
        <TextField
          value={email}
          onChange={e => {
            setEmail(e.target.value)
            if (error) setError(false)
          }}
          width={1 / 1}
          placeholder={t("identity_consent.email_placeholder", "")}
          error={error && t("identity_consent.email_error", "")}
          mt={3}
        />
      </Flex>
      <Flex flexDirection="row" py={2} px={[3, 4]} justifyContent="space-between">
        <Button variant="text.dark.1" elevation={0} onClick={onPrevious} my={2} mx={[3, 4]}>
          {t("identity_consent.cancel", "")}
        </Button>
        <Button my={2} variant="primary.0" onClick={handleNext} data-testid="survey-next-btn">
          {t("identity_consent.next", "")}
        </Button>
      </Flex>
    </Card>
  )
}

export default forcedIdentityConsentContainer(ForcedIdentityConsent)
